var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-navbar-brand"},[_vm._t("default"),_vm._v(" "),_c('button',{staticClass:"m-navbar-toggler",on:{"click":_vm.handleToggle}},[_c('span',{staticClass:"m-icon-bar"}),_vm._v(" "),_c('span',{staticClass:"m-icon-bar"}),_vm._v(" "),_c('span',{staticClass:"m-icon-bar"})])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6a5d198","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/m/navbar/navbar-brand.vue
// module id = 6FoM
// module chunks = 90